import React, { useState, useCallback } from "react";
import { useSelector } from 'react-redux';
import { useSessionSetupFlow } from "../hooks/useSessionSetupFlows";
import HeroCardLayout from "./layout/HeroCardLayout";
import MicrophonePermissioningContainer from "./entryflow/MicrophonePermissioningContainer";
import LoadingSessionComponent from "./entryflow/LoadingSession";
import { getSessionSpec } from "../utils/sessionEndpoints";
import { useNavUtils } from "../utils/navUtils";
import { selectActivePixelStreamingExperience } from "../store/userSlice";
import { 
  selectResLinkParamsId,
  selectOrganizationId,
} from '../store/experienceSlice';
import LoadingSessionErrorComponent from "./entryflow/LoadingSessionError";

type SubClientEntryState =
  | "microphonepermissioning"
  | "sessioncreating"
  | "sessionloadingerror";

const SubClientEntry: React.FC = () => {
  const { goNav } = useNavUtils();
  const { handleManualSessionSetup } = useSessionSetupFlow();

  const activePixelStreamingExperience = useSelector(selectActivePixelStreamingExperience);
  const organizationId = useSelector(selectOrganizationId); 
  const resLinkParamsId = useSelector(selectResLinkParamsId);

  const [currentView, setCurrentView] = useState<SubClientEntryState>("microphonepermissioning");
  const [statusMessage, setStatusMessage] = useState<string | null>(null);
  
  const launchSession = useCallback(async () => {
    console.log("[SubClientEntry] launchSession, activePixelStreamingExperience orgId:", organizationId, " resLinkParamsId:", resLinkParamsId);
    const sessionSpec = getSessionSpec(organizationId || "", undefined, undefined, resLinkParamsId);
    setCurrentView("sessioncreating");
    try {
      await handleManualSessionSetup(sessionSpec);
      goNav("/avatarstreamer");
    } catch (err) {
      let msg: string = "";
      if (err instanceof Error) {
        msg = err.message || "Failed to create session.";
      } else {
        msg = "Unknown error creating session.";
      }
      setStatusMessage(msg);
      setCurrentView("sessionloadingerror");
    }
  }, [goNav, handleManualSessionSetup, activePixelStreamingExperience, organizationId, resLinkParamsId]);

  if (currentView === "sessioncreating") {
    return <LoadingSessionComponent />;
  }

  if (currentView === "sessionloadingerror") {
    return <LoadingSessionErrorComponent 
      errorMessage={statusMessage}
      onRetry={launchSession} />;
  }

  if (currentView === "microphonepermissioning") {
    return (
      <HeroCardLayout>
        <MicrophonePermissioningContainer 
          onMicrophonePermissioned={launchSession} 
          botName={activePixelStreamingExperience?.bot_name} />
      </HeroCardLayout>
    );
  }

  return (
      <HeroCardLayout showCard={false}>{null}</HeroCardLayout>
  )
}

export default SubClientEntry;